@use "ui/styles/colors";
@use "ui/styles/fonts";
@use "ui/styles/sizes";
@use "ui/styles/breakpoints";

.wrapper {
  align-items: center;
  display: flex;
  gap: 6px;
  font-size: fonts.$mid;
  font-weight: fonts.$bold;
  color: var(--text-color, #{colors.$brandBlack});
  white-space: nowrap;

  .beta {
    height: sizes.$s6;
    padding: 0 sizes.$s4;

    > span {
      font-size: fonts.$smallX1;
    }

    background-color: colors.$brandDarkGray;
    color: colors.$brandWhite;
  }

  @include breakpoints.mobile {
    .name {
      display: none;
    }
  }
}